import React from "react";
import Speackers from "../Components/Speackers";

const Agenda = () => {
  return (
    <section className="container mx-auto">
      <Speackers />
    </section>
  );
};

export default Agenda;
